import axios from "./axios";

class Routes {
  async fetch_roles() {
    const response = await axios.get(`/fetch_roles`);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async fetch_admin_user(userId) {
    const response = await axios.get(`/fetch_admin_user`, {
      params: { userId }
    });
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async fetch_admin_users() {
    const response = await axios.get(`/fetch_admin_users`);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async add_admin_user(data) {
    const response = await axios.post(`/add_admin_user`, data)

    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async delete_admin_user(adminUserId) {
    const response = await axios.delete(`/delete_admin_user/${adminUserId}`)

    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async edit_admin_user(adminUserId, data) {
    const response = await axios.patch(`/edit_admin_user/${adminUserId}`, data)

    if (response && response.response?.data) return response.response.data;
    return response.data;
  }

  async add_role(data) {
    const response = await axios.post(`/add_role`, data);
    if (response && response.response?.data) return response.response.data;
    return response.data;
  }
}

export default new Routes();